module.exports = __webpack_public_path__ + "static/img/1-1.bb0b2be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/1-1.png
// module id = 0ILV
// module chunks = 0